import { fetchState } from '@/store/extensions/fetch';
import { createState } from '@/store/extensions/create';
import { updateState } from '@/store/extensions/update';
import { deleteState } from '@/store/extensions/delete';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  ...fetchState,
  ...createState,
  ...updateState,
  ...deleteState,

  updating: false,
  formModalOpened: false,
  formModalContext: null,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};




// WEBPACK FOOTER //
// ./src/store/modules/ptoAvailability/index.js